import {Transaction} from '../../components/transaction/transaction.types';

export const TRANSACTIONS: Omit<Transaction, 'onClick'>[] = [
	{
		value: '1000',
		type: 'decrease',
		time: '14 days',
		img: '/img/transactions/01.png',
	},
	{
		value: '2000',
		type: 'increase',
		time: '2 hours',
		img: '/img/transactions/02.png',
	},
];

export const NFT_LIST = [
	{
		img: '/img/assets/nft/item01.png',
		name: 'Khruangbin',
		voted: '14',
		value: '2,000',
	},
	{
		img: '/img/assets/nft/item02.png',
		name: 'Ana Popović',
		voted: '20',
		value: '3,000',
	},
];
